Galeria = {

    elm:{},
    
    Gallery:{
        slider:{},
        overlay:{},
        thumbs:{},
        close:{},

        init:function(){

            console.log("Gallery.init");

            Galeria.Gallery.thumbs = $('.galleria .thumb');
            if (!Galeria.Gallery.thumbs) return;

            Galeria.elm =  $('<div>', {'class':'sb-gallery-slider'}).appendTo('body');
           

            Galeria.Gallery.thumbs.click(function(event) {
                Galeria.Gallery.create($(this).attr('slide'));
            });
        },

        create: function(nmb){

            Galeria.Gallery.overlay = $('<div>', {'class':'overlay-bg'}).appendTo(Galeria.elm);
            Galeria.Gallery.slider = $('<sitelab:module class="slider" data-slideshow="true" data-layout="fullscreen" data-thumbs="bottom" data-animation="basic" data-arrows="true" data-arrowshide = "false" data-pictureadapt="false"><div class="master-slider ms-skin-light-3 galeria" id="gall"></div></sitelab:module>')
            Galeria.Gallery.slider.appendTo(Galeria.elm);

            Galeria.Gallery.button = $('<div>', {'class':'button close icon-close'}).appendTo(Galeria.elm);
            Galeria.Gallery.button.click(function(event) {
                Galeria.Gallery.hide();
            })
                

            Galeria.Gallery.generate(nmb);
        },

        generate: function(nmb){

            Galeria.Gallery.thumbs.each(function(index, el) {

                var src = $(this).attr('img');

                var slide = $('<div>',{'class':"ms-slide"})
                
                var img = $('<img>', {'src':WEB_ROOT + "/lib/master-slider/style/blank.gif", 'data-src':src}).appendTo(slide);
                var thumb = $('<img>', {'src':src + '?w=285&h=160', 'class':"ms-thumb"}).appendTo(slide);

                slide.appendTo(Galeria.Gallery.slider.find('.master-slider'))
                
            });

            Galeria.Gallery.show(nmb);
        },

        show: function(nmb){
            initGalleries();
            $('.master-slider').masterslider('gotoSlide' , nmb)
            Galeria.Gallery.overlay.addClass('show');
            Galeria.Gallery.slider.addClass('show');

            // $('body,html').css('overflow', 'hidden');
        },

        hide: function(){
            Galeria.Gallery.overlay.addClass('hide');
            Galeria.Gallery.slider.addClass('hide');
            Galeria.Gallery.button.remove();

            setTimeout(function(){
                Galeria.Gallery.overlay.remove();
                Galeria.Gallery.slider.remove();
            },700)

            // $('body,html').css('overflow', '');
        }
    }
};